<template>
  <div class="form-certification">
    <edit-table
      :option="option"
      :data="data"
      :form.sync="forms"
      @submit-add="handleSubmit"
      @submit-edit="handleUpdate"
      @refresh-change="refreshChange"
      @rowDel="handleRowDel"
    />
  </div>
</template>

<script>
import EditTable from '@/components/editTable/index.vue'
import WORKER from '@/api/worker/index'

export default {
  components: {
    EditTable,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    currentId: {
      type: String,
      default: '',
    },
    detailType: {
      type: String,
      default: 'view',
    },
  },
  data() {
    return {
      projectData: [],
      hasToStringTypes: ['select'],
      forms: {
        status: 1,
      },
    }
  },
  computed: {
    option() {
      const option = {
        drawer: true,
        menu: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        columns: [
          {
            label: 'Team',
            field: 'teamName',
          },

          {
            label: this.i18n('startDate'),
            field: 'teamJoinDate',
            dateInputFormat: 'yyyy-MM-dd',
            dateOutputFormat: 'MMM do yy',
            formOption: {
              type: 'date',
            },
          },
          {
            label: this.i18n('endDate'),
            field: 'teamLeftDate',
            dateInputFormat: 'yyyy-MM-dd',
            dateOutputFormat: 'MMM do yy',
            formOption: {
              type: 'date',
            },
          },
        ],
      }
      return option
    },
    form() {
      const res = []
      this.data.forEach((row) => {
        const temp = row
        this.option.columns.forEach((item) => {
          if (this.hasToStringTypes.indexOf(item.type) !== -1) {
            temp[item.field] = row[item.field].toString()
          }
        })
        res.push(temp)
      })
      return res
    },
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    // 国际化
    i18n(param) {
      return this.$t(`_staff.labelProject.${param}`)
    },

    refreshChange() {
      this.onLoad()
    },

    async onLoad() {
      console.log(WORKER)
      const res = await WORKER.getWorkBaseDetail({ workerID: this.currentId })
      this.data = res.data.data.teamRecord || []
    },
  },
}
</script>
<style lang="scss">
.form-certification {
  &-top {
    text-align: right;
  }
  .table-td {
    text-align: center;
    line-height: 50px;
    &-sm {
      width: 200px;
    }
  }
}
</style>
